import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';


export const confirmRescheduleDelivery = createAsyncThunk(
  "rescheduleDelivery/confirmRescheduleDelivery",
  async (data, thunkApi) => {
    try {
      const response = await agent.requests.post(
        "/subscriptions/reschedule-pending-delivery",
        data
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


const initialState = {
  status: 'idle',
  confirmRescheduleDeliveryResponse: null,
  error: null,
};


const rescheduleDeliverySlice = createSlice({
  name: 'rescheduleDelivery',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder

   
      // POST CONFIRM
      .addCase(confirmRescheduleDelivery.pending, (state) => {
        state.status = "confirmRescheduleDelivery/loading";
      })
      .addCase(confirmRescheduleDelivery.fulfilled, (state, action) => {
        state.status = "confirmRescheduleDelivery/success";
        state.confirmRescheduleDeliveryResponse = action.payload;
      })
      .addCase(confirmRescheduleDelivery.rejected, (state, action) => {
        state.status = "confirmRescheduleDelivery/failed";
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = rescheduleDeliverySlice.actions;

export const selectPendingUpdateDetailsStatus = (state) =>
  state.rescheduleDelivery.status;

export const confirmRescheduleDeliveryResponse = (state) =>
  state.rescheduleDelivery.confirmRescheduleDeliveryResponse;

export const confirmRescheduleDeliveryError = (state) =>
  state.rescheduleDelivery.error;

export default rescheduleDeliverySlice.reducer;






